import { API_BASE_URL_ENV } from "../../jsx/common/common";
import BaseService from "../BaseService";

const apiEndpoint = API_BASE_URL_ENV() + "/departments";

export default class DepartmentService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
